
(function($) {

	var	$window = $(window),
		$body = $('body');

	// Breakpoints.
		breakpoints({
			xlarge:   [ '1281px',  '1680px' ],
			large:    [ '981px',   '1280px' ],
			medium:   [ '737px',   '980px'  ],
			small:    [ '481px',   '736px'  ],
			xsmall:   [ null,      '480px'  ]
		});

	// Play initial animations on page load.
		$window.on('load', function() {
			window.setTimeout(function() {
				$body.removeClass('is-preload');
			}, 100);
		});

	// Touch mode.
		if (browser.mobile)
			$body.addClass('is-touch');

	// Scrolly links.
		$('.scrolly').scrolly({
			speed: 2000
		});

	// Header
	$("#header-placeholder").load('/components/header.html', function() {
		const currentPage = window.location.pathname.split("/").pop();
		if(currentPage === "" || currentPage === "index.html"){
			$("#header").addClass('main-p');
		}

		if(currentPage === "contact_us.html"){
			$("#nav").hide();
			$("#header").addClass('contact-p');
		}
	});

	$("#footer-placeholder").load('/components/footer.html');

	// Parallax.
	// Disabled on IE (choppy scrolling) and mobile platforms (poor performance).
		if (browser.name == 'ie'
		||	browser.mobile) {

			$.fn._parallax = function() {

				return $(this);

			};

		}
		else {

			$.fn._parallax = function() {

				$(this).each(function() {

					var $this = $(this),
						on, off;

					on = function() {

						$this
							.css('background-position', 'center 0px');

						$window
							.on('scroll._parallax', function() {

								var pos = parseInt($window.scrollTop()) - parseInt($this.position().top);

								$this.css('background-position', 'center ' + (pos * -0.15) + 'px');

							});

					};

					off = function() {

						$this
							.css('background-position', '');

						$window
							.off('scroll._parallax');

					};

					breakpoints.on('<=medium', off);
					breakpoints.on('>medium', on);

				});

				return $(this);

			};

			$window
				.on('load resize', function() {
					$window.trigger('scroll');
				});

		}

	// Banner.
		var $banner = $('#banner');

		$banner
			._parallax();

	// Contact-us page. 
	document.addEventListener('DOMContentLoaded', function () {
		const cactusSvg = document.getElementById('cactus-svg');

		if(cactusSvg === null){
			return;
		}
	
		const observer = new IntersectionObserver((entries) => {
			entries.forEach(entry => {
				if (entry.isIntersecting) {
					// Add animation or update position
					cactusSvg.style.bottom = '20%';
				} else {
					// Reset position when out of view
					cactusSvg.style.bottom = '25%';
				}
			});
		});
	
		observer.observe(cactusSvg);
	});

	const observer = new IntersectionObserver(entries => {
		entries.forEach(entry => {
		  if (entry.isIntersecting) {
			entry.target.classList.add('pin-icon-animation');
			return;
		  }
		  entry.target.classList.remove('pin-icon-animation');
		});
	  });
	  const pinIcons = document.querySelectorAll('.pin-icon');
	  pinIcons.forEach((element) => observer.observe(element));

})(jQuery);